var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgWalletCard(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_452_20149)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.5 17C19.8785 17 21 15.8785 21 14.5C21 13.1215 19.8785 12 18.5 12C17.1215 12 16 13.1215 16 14.5C16 15.8785 17.123 17 18.5 17ZM18.5 12.5829C19.5572 12.5829 20.4186 13.4428 20.4186 14.5015C20.4186 15.5603 19.5588 16.4201 18.5 16.4201C17.4412 16.4201 16.5814 15.5603 16.5814 14.5015C16.5814 13.4428 17.4428 12.5829 18.5 12.5829Z",
    fill: "#150036",
    stroke: "#150036"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.9944 4H3.00559C1.89919 4 1 5.10228 1 6.45858V17.5414C1 18.8977 1.89919 20 3.00559 20H20.9944C22.1008 20 23 18.8977 23 17.5414V6.45858C22.9987 5.10228 22.0996 4 20.9944 4ZM22.5228 9.11729V17.5414C22.5228 18.5744 21.8371 19.415 20.9944 19.415H3.00559C2.16292 19.415 1.47722 18.5744 1.47722 17.5414V9.11729H22.5228ZM22.5228 8.53228H1.47722V6.80804H22.5228V8.53228ZM3.00559 4.58501H20.9944C21.7718 4.58501 22.4148 5.30088 22.509 6.22303H1.49104C1.58523 5.30088 2.22822 4.58501 3.00559 4.58501Z",
    fill: "#150036",
    stroke: "#150036"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_452_20149"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(24 24) rotate(180)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWalletCard);
export default __webpack_public_path__ + "static/media/WalletCard.e0c86aad0933f4c4390617d61f10e0bb.svg";
export { ForwardRef as ReactComponent };